'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.easel = exports.images = exports.tokenProvider = undefined;

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // fallback to doing nothing


var Raven = null;

try {
  Raven = require('raven-js');
} catch (e) {// raven-js is an optional peer dependency
}

_bluebird2.default.promisifyAll(_superagent2.default);

var requestFactory = function requestFactory(options) {
  options = options || {};
  var method = options.method || 'post';
  var url = options.url;
  var json = JSON.stringify(options.data);

  var requestInstance = _superagent2.default[method](url).set('Accept', 'application/json').set('Content-Type', 'application/json').set('X-Canvas-Auth', options.token).send(json);

  if (Raven !== null) {
    requestInstance.on('response', function (response) {
      if (response.error) {
        Raven.captureException(response.toError(), {
          tags: {
            method: method,
            url: url,
            status: response.status,
            data: json
          }
        });
      }
    });
  }

  return requestInstance;
};

var tokenProvider = exports.tokenProvider = {
  baseUri: 'https://marvelapp.com',
  newCanvas: function newCanvas(projectId) {
    console.group('Register New Canvas with Backend');
    console.log('make request to backend');
    return requestFactory({
      url: tokenProvider.baseUri + '/api/token/canvas/' + projectId + '/'
    }).withCredentials().endAsync().then(function (response) {
      console.log('make request to backend -- done');
      return response;
    }).catch(function (err) {
      console.warn('make request to backend -- failed', err);
      return _bluebird2.default.reject(err);
    }).finally(function () {
      console.groupEnd();
    });
  },
  newComponent: function newComponent() {
    return requestFactory({
      url: tokenProvider.baseUri + '/api/token/canvas/library/component/'
    }).withCredentials().endAsync();
  },
  newCanvasForContent: function newCanvasForContent(projectId, contentId) {
    console.group('Register New Content Canvas with Backend');
    console.log('make request to backend');
    return requestFactory({
      url: tokenProvider.baseUri + '/api/canvas/set-canvas-id/',
      data: {
        project_id: projectId,
        content_id: contentId
      }
    }).withCredentials().endAsync().then(function (response) {
      console.log('make request to backend -- done');
      return response;
    }).catch(function (err) {
      console.warn('make request to backend -- failed', err);
      return _bluebird2.default.reject(err);
    }).finally(function () {
      console.groupEnd();
    });
  },
  getAuth: function getAuth(id, projectId) {
    var url = void 0; // TODO: split this out into separate methods to make intent clearer
    // When refactoring, ensure that token refreshing works as expected

    if (projectId) {
      url = tokenProvider.baseUri + '/api/token/canvas/' + projectId + '/' + id + '/';
    } else {
      url = tokenProvider.baseUri + '/api/token/canvas/library/component/' + id + '/';
    }

    console.log('get new token');
    return requestFactory({
      url: url
    }).withCredentials().endAsync().then(function (response) {
      console.log('get new token -- done');
      return response;
    }).catch(function (err) {
      console.warn('get new token -- failed', err);
      return _bluebird2.default.reject(err);
    });
  }
};
var images = exports.images = {
  baseUri: 'https://marvelapp.com',
  csrfToken: null,
  csrfTokenHeader: 'X-CSRFToken',
  _backoffMultiplier: 1000,
  upload: function upload(blob, uuid) {
    var url = this.baseUri + '/api/content/canvas/upload/';

    if (uuid) {
      url += uuid + '/';
    }

    var maxTries = 5;
    var tries = 0;
    var backoffMultiplier = this._backoffMultiplier;

    function reqFactory(url, blob, csrfToken, csrfTokenHeader) {
      tries += 1;

      var req = _superagent2.default.post(url).attach('file', blob).withCredentials();

      if (csrfToken) {
        req.set(csrfTokenHeader, csrfToken);
      }

      if (Raven !== null) {
        req.on('response', function (response) {
          if (response.error) {
            Raven.captureException(response.toError(), {
              tags: {
                method: 'post',
                url: url,
                status: response.status
              }
            });
          }
        });
      }

      return req.endAsync().then(function (resp) {
        return resp.body;
      }).catch(function (err) {
        if (tries < maxTries) {
          var delay = Math.pow(2, tries) * backoffMultiplier; // exponential backoff

          return _bluebird2.default.delay(delay).then(function () {
            return reqFactory(url, blob, csrfToken, csrfTokenHeader);
          });
        } else {
          return _bluebird2.default.reject(new Error('Upload failed', err));
        }
      });
    }

    return reqFactory(url, blob, this.csrfToken, this.csrfTokenHeader);
  },
  urlIsMarvelURL: function urlIsMarvelURL(url) {
    return url.search(/https:\/\/marvelapp-(dev|live)\.storage\.googleapis\.com\/canvas\//) !== -1 || url.search(/https:\/\/marvel-(dev|live)\.freetls.fastly.net\/canvas\//) !== -1;
  },
  uploadFromURL: function uploadFromURL(imageURL, uuid) {
    if (this.urlIsMarvelURL(imageURL)) {
      return _bluebird2.default.resolve({
        url: imageURL
      });
    }

    var url = this.baseUri + '/api/content/canvas/upload-from-url/';
    var body = {
      url: imageURL
    };

    if (uuid) {
      body.uuid = uuid;
    }

    var maxTries = 5;
    var tries = 0;
    var backoffMultiplier = this._backoffMultiplier;

    function reqFactory(url, body, csrfToken, csrfTokenHeader) {
      tries += 1;

      var req = _superagent2.default.post(url).send(body).withCredentials();

      if (csrfToken) {
        req.set(csrfTokenHeader, csrfToken);
      }

      if (Raven !== null) {
        req.on('response', function (response) {
          if (response.error) {
            Raven.captureException(response.toError(), {
              tags: {
                method: 'post',
                url: url,
                status: response.status
              }
            });
          }
        });
      }

      return req.endAsync().then(function (resp) {
        return resp.body;
      }).catch(function (err) {
        if (tries < maxTries) {
          var delay = Math.pow(2, tries) * backoffMultiplier; // exponential backoff

          return _bluebird2.default.delay(delay).then(function () {
            return reqFactory(url, body, csrfToken, csrfTokenHeader);
          });
        } else {
          return _bluebird2.default.reject(new Error('Upload failed', err));
        }
      });
    }

    return reqFactory(url, body, this.csrfToken, this.csrfTokenHeader);
  }
};
var easel = exports.easel = {
  baseUri: 'https://easel.marvelapp.com',
  versionPathString: 'v2',
  create: function create(token, body) {
    var url = easel.baseUri + '/' + easel.versionPathString + '/canvas/';
    console.groupCollapsed('Easel Create');
    console.log('calling ' + url);
    return requestFactory({
      token: token,
      url: url,
      data: body
    }).endAsync().then(function (response) {
      console.log('create -- done');
      return response;
    }).catch(function (err) {
      console.warn('create -- failed', err);
      return _bluebird2.default.reject(err);
    }).finally(function () {
      console.groupEnd();
    });
  },
  save: function save(token, id, body) {
    var url = easel.baseUri + '/' + easel.versionPathString + '/canvas/' + id + '/';
    console.groupCollapsed('Easel Save');
    console.log('calling ' + url);
    return requestFactory({
      token: token,
      url: url,
      data: body,
      method: 'put'
    }).endAsync().then(function (response) {
      console.log('save -- done');
      return response;
    }).catch(function (err) {
      console.warn('save -- failed', err);
      return _bluebird2.default.reject(err);
    }).finally(function () {
      console.groupEnd();
    });
  },
  fetch: function fetch(token, id) {
    var url = easel.baseUri + '/' + easel.versionPathString + '/canvas/' + id + '/';
    return _fetch(url, token, id);
  },
  fetchCode: function fetchCode(token, id, type) {
    var url = easel.baseUri + '/' + easel.versionPathString + '/canvas/' + id + '/code-snippet/' + type + '/';
    return _fetch(url, token, id);
  },
  delete: function _delete(token, id) {
    var url = easel.baseUri + '/' + easel.versionPathString + '/canvas/' + id + '/';
    console.groupCollapsed('Easel Fetch');
    console.log('calling ' + url);
    return requestFactory({
      token: token,
      url: url,
      method: 'delete'
    }).endAsync().then(function (response) {
      console.log('delete -- done');
      return response;
    }).catch(function (err) {
      console.warn('delete -- failed', err);
      return _bluebird2.default.reject(err);
    }).finally(function () {
      console.groupEnd();
    });
  }
}; // Generic fetch used in exported fetch methods

function _fetch(url, token, id) {
  console.groupCollapsed('Easel Fetch');
  console.log('calling ' + url);
  return requestFactory({
    token: token,
    url: url,
    method: 'get'
  }).endAsync().then(function (response) {
    console.log('fetch -- done');
    return response;
  }).catch(function (err) {
    console.warn('fetch -- failed', err);
    return _bluebird2.default.reject(err);
  }).finally(function () {
    console.groupEnd();
  });
}